const Input = {
    baseStyle: {
        field: {
            _placeholder: {
                // neutral.500 (#99A1AF) is 2.6:1 and fails 1.4.3 for placeholder text;
                // neutral.700 (#596273) is 5.4:1. BENG-4171 #23.
                color: 'neutral.700',
                fontWeight: 400,
            },
            bg: 'transparent',
            // neutral.500 (2.6:1) fails 1.4.11 for the field border; neutral.600
            // (#778295) is 3.9:1. BENG-4171 #24.
            borderColor: 'neutral.600',
            fontSize: 'var(--input-font-size)',
            fontWeight: 400,
            textAlign: 'left',
            transition: 'none',
        },
    },
    parts: ['addon', 'field', 'element', 'group'],
    variants: {
        ghost: {
            field: {
                border: 'none',
                borderRadius: 0,
                boxShadow: 'none',
                color: 'neutral.900',
                height: 5,
                padding: 0,
            },
        },
    },
};
export { Input };
export default Input;
